'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _createReducer;

var _lodash = require('lodash');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bdcoreNamedRoutes2 = _interopRequireDefault(_bdcoreNamedRoutes);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _createReducer2 = require('../createReducer');

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setFilter(filtersState, action) {
  var values = Array.isArray(action.values) ? action.values : [action.values];

  if (action.values && !(0, _lodash.isEqual)(filtersState[action.fieldName], values)) {
    return (0, _extends5.default)({}, filtersState, (0, _defineProperty3.default)({}, action.fieldName, values));
  } else if (!action.values && filtersState[action.fieldName]) {
    var field = filtersState[action.fieldName],
        newState = (0, _objectWithoutProperties3.default)(filtersState, [action.fieldName]);


    return newState;
  }

  return filtersState;
}

function clearFilters() {
  return {};
}

function filtersByUrl(filterState, action, state) {
  var matchedRoute = _bdcoreNamedRoutes2.default.getRouteByPath((0, _lodash.get)(state, 'router.location.pathname'));
  var query = _queryString2.default.parse(window.location.search);
  var excludeFromQuery = ['Area', 'AreaMetro', 'AreaSubMetro'];
  var queryFilters = (0, _lodash.has)(query, 'filters') ? JSON.parse(query.filters) : {};

  var queryFiltersState = (0, _keys2.default)(queryFilters).filter(function (filter) {
    return !excludeFromQuery.includes(filter);
  }).reduce(function (result, key) {
    return (0, _extends5.default)({}, result, (0, _defineProperty3.default)({}, key, (0, _lodash.get)(queryFilters, key, []).map(function (value) {
      return { value: value, label: value };
    })));
  }, {});
  var newState = {};

  if ((0, _lodash.has)(matchedRoute, 'keepFilters')) {
    newState = (0, _extends5.default)({}, filterState);
  }

  if ((0, _lodash.has)(matchedRoute, 'params.blogCategory')) {
    newState.Category = [(0, _lodash.get)(matchedRoute, 'params.blogCategory')];
  }

  if ((0, _lodash.has)(matchedRoute, 'params.blogTag')) {
    newState.Tag = [(0, _lodash.get)(matchedRoute, 'params.blogTag')];
  }

  return (0, _extends5.default)({}, filterState, newState, queryFiltersState);
}

var reducer = (0, _createReducer3.default)({}, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, _actions.SET_FILTER, setFilter), (0, _defineProperty3.default)(_createReducer, _actions.CLEAR_FILTERS, clearFilters), (0, _defineProperty3.default)(_createReducer, '@@router/LOCATION_CHANGE', filtersByUrl), _createReducer));

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Filters/reducer.js
// module id = 940
// module chunks = 0